var ProductJs = function( product, productBackorder ) {
	var item = $('#product-item-'+product.id+':not(.initialized):first');
	var variantSelectorId = "product-select-"+product.id;
	var productJs = this;

	var init = function() {
		if(item.length > 0) {
		  if($('[id='+variantSelectorId+']').length > 1) { //Change the id when the product is repeated
			  var rnd = Math.floor((Math.random() * 1000000000) + 1);
			  var newId = variantSelectorId + "-" + rnd;
			  item.find("#product-select-"+product.id).attr('id', newId);
			  variantSelectorId = newId;
		  }
		  asociateBackorders();
		  initVariantStatus();
		  initVariantExtendedOffer();
		  initializeVariantSelector();
		  initGallery();
		  processSoldOutProducts();
		  item.find('.loading-overlay').hide();
		  item.addClass('initialized');
		  item.data('product', product);

		  $(document).on('refreshVariantStatus', function(){
				initVariantStatus();
				updateSelectVariantDesc();
				item.find('.select-variant').change();
		  });
		  
		  /*if(!product.available) {
			item.find('.select-variant').val(product.variants[0].id).change();
		  }*/

		  item.data('productjs', productJs);
		}
	};

	productJs.getSelectedVariant = function() {
		var variantId = item.find('#product-'+product.id+'-variant').val();
		if(variantId && variantId!="") {
			return product.variants.find(x=>x.id==variantId);
		} else {
			return false;
		}
	}

	productJs.getProduct = function() {
		return product;
	}
  
	var processSoldOutProducts = function() {
		if(settings.hide_sold_out_products || settings.move_to_bottom_sold_out_products) {
			if(item.closest('#collection-grid').length>0) { //Only in the collection Grid
			  var productIsSoldOut = true;
			  $.each(product.variants, function(key, variant){
				  if(variant.status == 'soldout' && !isExtendedOffer(variant)) {
					  if(settings.hide_sold_out_products && product.options.length <= 1) {
						  item.find('.select-variant option[value='+variant.id+']').remove();
					  }
				  } else {
					  if(variant.status != 'soldout') {
						  productIsSoldOut = false;
					  }
				  }
			  });
			  if(productIsSoldOut) {
				  if(settings.hide_sold_out_products && !isExtendedOffer(product.variants[0])) {
					  item.remove();
				  }
				  if(settings.move_to_bottom_sold_out_products) {
					  item.appendTo(item.parent());
				  }
			  }
			}
		}
	}

	var asociateBackorders = function() {
		if(productBackorder) {
			$.each(product.variants, function(key, variant){
				$.each(productBackorder.variants, function(keyBack, variantBack){
					if(variant.title == variantBack.title) {
						variant.backorder = variantBack;
					}
				});
			}); 
		}
	};
	
	var initVariantStatus = function() {
		$.each(product.variants, function(key, variant){
			//ON HOLD
			if(isOnHold(variant)) {
				if(settings.show_backorders!='no' && variant.backorder && variant.backorder.available) {
					variant.status = 'onhold-backorder';
				} else {
					variant.status = 'onhold';
				}
			} else {
				//BACK ORDER
				if(isBackorder(variant)) {
					variant.status = 'backorder';
				} else {
					//AVAILABLE
					if(variant.available && settings.show_backorders!='yes') {
						variant.status = 'available';
					} else {
						//SOLDOUT
						variant.status = 'soldout';
					}
				}
			}
		})
	};
  
	var initVariantExtendedOffer = function() {
		$.each(product.variants, function(key, variant){
			variant.extendedOffer = isExtendedOffer(variant);
		});
	};
  
	var isExtendedOffer = function(variant) {
		var specificExtendedOffer = $.trim(settings.extended_offer_specific.replace(/\r/g, ''));

		if(settings.show_extended_offer=='product') {
		  var productStatus = getProductStatus();
		  if(productStatus=='soldout' || productStatus=='onhold') {
			if(specificExtendedOffer!="") {
			  specificExtendedOffer = specificExtendedOffer.split('\n');
			  if($.inArray(product.handle, specificExtendedOffer)>-1) {
				  return true;
			  }
			} else {
			  return true;
			}
		  }
		}
		if(variant) {
			if(settings.show_extended_offer=='variant') {
				if(variant.status=='soldout' || variant.status=='onhold') {
					if(specificExtendedOffer!="") {
						specificExtendedOffer = specificExtendedOffer.split('\n');
						if($.inArray(variant.sku, specificExtendedOffer)>-1) {
								return true;
						}
					} else {
						return true;
					}
				}
			} 
		}
		return false;
	};
  
	var getProductExtendedOffer = function() {
	  var extendedOffer;
	  $.each(product.variants, function(key, variant){
		if(key==0) {
		  extendedOffer = variant.extendedOffer;
		} else {
		  if(variant.extendedOffer!=extendedOffer) {
			extendedOffer = false;
		  }
		}
	  });
	  return extendedOffer;
	}
  
	var isOnHoldCategories = function(variant){
		var result = null;

		for(var i=1; i<=5; i++) {
			var productsOnHold = settings['on_hold_products_'+i].replace(/\r/g, '').split('\n');
			var variantsOnHold = settings['on_hold_variants_'+i].replace(/\r/g, '').split('\n');
			var stockOnHold = settings['on_hold_stock_'+i];
		  
			if((productsOnHold!="" && $.inArray(product.handle, productsOnHold)>-1) ||
			(variantsOnHold!="" && $.inArray(variant[settings['on_hold_variants_by_'+i]], variantsOnHold)>-1)) {
				if(stockOnHold=="" || variant.inventory_quantity<=stockOnHold) {
					result = true;
				} else {
					result = false;
				}
				break;
			}
		}
	  
		return result;
	};

	var isOnHold = function(variant) {
		if(settings.automatically_onhold && product.handle.indexOf("backorder") < 0) {
			var time = currentTime.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");
			var onholdDate = settings.automatically_onhold_date.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");

			if(onholdDate=="" || time<onholdDate) {
				var categoriesOnHold = isOnHoldCategories(variant);
				if(categoriesOnHold!=null) {
					return categoriesOnHold;
				} else {
					if(settings.automatically_onhold_stock!="" && variant.inventory_quantity<=settings.automatically_onhold_stock) {
						return true;
					}
				}
			}
		}

		return false;
	};
  
	var isBackorder = function(variant) {
		if((settings.show_backorders=='yes' || (settings.show_backorders=='auto' && !variant.available)) && variant.backorder && variant.backorder.available) {
			return true;
		}
		return false;
	}
	
	var getProductStatus = function() {
	  var status;
	  $.each(product.variants, function(key, variant){
		if(key==0) {
		  status = variant.status;
		} else {
		  if(variant.status!=status) {
			status = 'available';
		  }
		}
	  });
	  return status;
	}
	
	var initializeVariantSelector = function() {
		var selectCallback = onVariantSelected();
	  
		if(product.options.length > 1) {
			new Shopify.OptionSelectors(variantSelectorId, { product: product, onVariantSelected: selectCallback });

			if(product.variants.length > 1) {
			  $.each(product.options, function(key, variant){
				item.find('.single-option-selector:eq('+key+')')
				.filter(function() { return $(this).find('option').size() > 1  })
				.prepend('<option value="">- Select -</option>')
				.val('')
				.trigger('change');
			  });
			}

			// Add label if only one product option and it isn't 'Title'.
			if(product.options.length == 1 && product.options[0] != 'Title') {
			  item.find('.selector-wrapper:eq(0)').prepend('<label>'+product.options[0]+'</label>');
			}
			item.find('.selector-wrapper label').append(':');
		} else {
			item.find('.select-variant').change(function(){
			  var variantSelected = false;
			  $.each(product.variants, function(key, variant){
				if(variant.id==item.find('.select-variant').val()) {
				  variantSelected = variant;
				  return;
				}
			  });
			  selectCallback(variantSelected, null);
			});
			if(product.variants.length > 1) {
				updateSelectVariantDesc();
				selectCallback(false, null);
			}
		}
	  
		if(product.variants.length==1) {
			selectCallback(product.variants[0], null);
		}
	};
  
	var updateSelectVariantDesc = function() {
		item.find('.select-variant option').each(function(){
			var value = $(this).val();
			var variant = $.grep(product.variants, function(obj){ return obj.id==value; });
			var text = $(this).text().replace(' - BACK ORDER', '').replace(' - ON HOLD', '').replace(' - EXTENDED OFFER', '').replace(' - SOLD OUT', '');
			if(variant[0]) {
				switch(variant[0].status) {
					case "backorder":
						text = text + ' - BACK ORDER';
						break;
					case "onhold-backorder":
						text = text + ' - BACK ORDER';
						break;
					case "onhold":
						text = text + ' - ON HOLD';
						break;
					case "soldout":
						if(variant[0].extendedOffer) {
							text = text + ' - EXTENDED OFFER';
						} else {
							if(settings.hide_sold_out_variants) {
							  $(this).remove();
							} else {
							  text = text + ' - SOLD OUT';
							}
						}
						break;
				}
				$(this).text(text);
			}
		});
	}

	var onVariantSelected = function() {
		return function(variant, selector) {
			if(variant && variant.id) {
				item.find('.starts-at').hide();

				//Update the price
				item.find('[data-price="deal"]').html( (Shopify.formatMoney ? Shopify.formatMoney(variant.price, formatMoney) : (variant.price/100).toString()).replace('.00', '').replace(' ', ''));
				if(variant.compare_at_price != null){
					item.find('[data-price="retail"]').html( (Shopify.formatMoney ? Shopify.formatMoney(variant.compare_at_price, formatMoney) : (variant.compare_at_price/100).toString()).replace('.00', '').replace(' ', ''));
					var percent = Math.floor( (((variant.compare_at_price - variant.price) * 100 ) / variant.compare_at_price) + 0.1 );
					item.find('.off-percent strong').html(percent+'%');
				}

				//Update the fetured image
				if(variant.featured_image) {
					//Image in grid
					item.find('.image .img:first').css('background-image', 'url('+variant.featured_image.src+')');

					//Image in product page
					if(item.find('#product-gallery') && !item.find('#product-gallery').hasClass('display-Slider')) {
						item.find('.main-images img').attr('src', variant.featured_image.src);
						item.find('.main-images a').attr('href', variant.featured_image.src);
					} else {
						//Slick Carousel
						if(item.find("#product-gallery .main-images").hasClass('slick-initialized')) {
						  item.find('#product-gallery .main-images .active-wrapper:not(.slick-cloned) a').each(function(key, obj){  
							  if($(this).attr('href').substr($(this).attr('href').indexOf('//'), $(this).attr('href').indexOf('?')).replace('_1200x', '') == 
							  variant.featured_image.src.substr(variant.featured_image.src.indexOf('//'), variant.featured_image.src.indexOf('?'))){
								  item.find("#product-gallery .main-images").slick('slickGoTo', key);
								  return false;
							  }
						  });
						}
					}
				}

				//Update the variant value to add to cart
				if(variant.status=='backorder' || variant.status=='onhold-backorder') {
					item.find('#product-'+product.id+'-variant').val(variant.backorder.id);
				} else {
					item.find('#product-'+product.id+'-variant').val(variant.id);
				}
			} else {
				item.find('#product-'+product.id+'-variant').val("");
				item.find('.starts-at').show();
			}
			updateButtons(variant);
			updateExtendedOffer(variant);
		  
			$(document).trigger('variantSelected', {item: item, variant: variant});
		}
	};
	
	var updateButtons = function(variant) {
		var status = variant ? variant.status : getProductStatus();
		var extendedOffer = variant ? variant.extendedOffer : getProductExtendedOffer();
		item.removeClass('item-available').removeClass('item-backorder').removeClass('item-hold-backorder').removeClass('item-hold').removeClass('item-soldout');
		item.find('.buttons-wrapper .add-button, .buttons-wrapper .backorder-button, .buttons-wrapper .sold-out-button, .buttons-wrapper .on-hold-button, .status-bar.onhold-backorder, .status-bar.backorder, .status-bar.onhold, .status-bar.onhold-eo, .status-bar.soldout, .status-bar.soldout-eo').hide(); //Grid
		item.find('.content-available, .content-backorder, .content-onhold, .content-onhold-backorder, .content-soldout').hide(); //Product page
		switch(status) {
			case "available":
				item.addClass('item-available');
				item.find('.buttons-wrapper .add-button').show(); //Grid
				item.find('.content-available').show(); //Product page
				break;
			case "backorder":
				item.addClass('item-backorder');
				item.find('.buttons-wrapper .backorder-button').show(); //Grid
				item.find('.status-bar.backorder').show(); //Grid
				item.find('.content-backorder').show(); //Product page
				break;
			case "onhold-backorder":
				item.addClass('item-hold-backorder');
				item.find('.buttons-wrapper .backorder-button').show(); //Grid
				item.find('.status-bar.onhold-backorder').show(); //Grid
				item.find('.content-onhold-backorder').show(); //Product page
				break;
			case "onhold":
				item.addClass('item-hold');
				item.find('.buttons-wrapper .on-hold-button').show(); //Grid
				if(extendedOffer) {
				  item.find('.status-bar.onhold-eo').show(); //Grid
				} else {
				  item.find('.status-bar.onhold').show(); //Grid
				}
				item.find('.content-onhold').show(); //Product page
				break;
			case "soldout":
				item.addClass('item-soldout');
				item.find('.buttons-wrapper .sold-out-button').show(); //Grid
				if(extendedOffer) {
				  item.find('.status-bar.soldout-eo').show(); //Grid
				} else {
				  item.find('.status-bar.soldout').show(); //Grid
				}
				item.find('.content-soldout').show(); //Product page
				break;
		}
	};
  
	var updateExtendedOffer = function(variant) {
		var extendedOffer = variant ? variant.extendedOffer : getProductExtendedOffer();
		var extendedOfferItem = product.title;
		if(variant) {
		  if(variant.title.toLowerCase() != 'default title') {
			extendedOfferItem += ' / ' + variant.title;
		  }
		}
		item.find('.extendedOfferPopUp').attr('variant-title', extendedOfferItem);

		if(extendedOffer) {
		  item.addClass('extended-offer');
		  item.find('.extended-offer-wrapper').show();
		  item.find('.button-with-extended-offer').show();
		  item.find('.button-without-extended-offer').hide();
		} else {
		  item.removeClass('extended-offer');
		  item.find('.extended-offer-wrapper').hide();
		  item.find('.button-with-extended-offer').hide();
		  item.find('.button-without-extended-offer').show();
		}
	};
  
	var initGallery = function(){
		//Initialize zoom on main product image
		var initializeZoom = function(index) {
		  if(item.find('.product-gallery').hasClass('zoom-in') && !isMobile.any) {
			  var mainProductImage = item.find('.slide:not(.slick-cloned) .large-thumb:eq('+index+')');
			  if(mainProductImage.length>0 && mainProductImage.parent().find('.zoomImg').length==0) {
				var zoomedSrc = mainProductImage.data('file');
				mainProductImage.wrap('<span style="display:block"></span>').css('display', 'block').parent().zoom({
				  url: zoomedSrc, 
				  callback: function(){
					item.find('.active-wrapper img.zoomImg').prop('alt', '');
				  } 
				});
			  }
		  }
		};
		item.find('.main-images').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		  var nextImage = $(this).find('.slide:not(.slick-cloned) .large-thumb:eq('+nextSlide+')');
		  if(!nextImage.hasClass('lazyloaded')) {
			nextImage.addClass('lazyload');
		  }

		  if(item.find('.thumbs .slick-track').length>0) {
			item.find('.thumbs.switch .slick-slide a').removeClass('active');
			item.find('.thumbs.switch .slick-slide:not(.slick-cloned):eq('+nextSlide+') a').addClass('active');

			var slidesToShow = item.find('.thumbs.switch').slick('slickGetOption', 'slidesToShow');
			if(slidesToShow==1) {
			  item.find('.thumbs.switch').slick('slickGoTo', nextSlide);
			} else {
			  item.find('.thumbs.switch').slick('slickGoTo', nextSlide-Math.floor((slidesToShow-1)/2));
			}
		  }

		  initializeZoom(nextSlide);
		});
	  
		if(!isMobile.any && item.find('#product-gallery').hasClass('zoom-in')) { 
		  Simplistic.onImagesLoaded(item.find('.main-images img'), function(){
			initializeZoom(item.find('.active-wrapper:not(.slick-cloned)').index(item.find('.active-wrapper.slick-active')));
		  });
		}
	  
	   var switchImage = function(newImageSrc, mainImageDomEl) {
		  $(mainImageDomEl).attr('src', newImageSrc);
		  if(!isMobile.any && item.find('#product-gallery').hasClass('zoom-in')) { 
			$(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc } ); 
		  }
		  $(mainImageDomEl).parents('a').attr('href', newImageSrc);
		};

		//Initialize thumbs on PDP
		item.find('#thumbs.switch a').on('click', function(e) { 
			e.preventDefault();
			var variantId = $(this).attr('variant-id');

			item.find('#thumbs.switch a').removeClass('active');
			$(this).addClass('active');
		  
			if(!item.find('#product-gallery').hasClass('display-Slider')) {
				switchImage($(this).attr('href'), item.find('.main-images img')[0]);
			}
			if(variantId && variantId!='') {
				if(product.options.length <= 1) {
					item.find('.select-variant').val(variantId).change();
				} else {
					var variantTitle = item.find('.select-variant option[value='+variantId+']').text();
					$.each(variantTitle.split(' / '), function(key, val){
						item.find('.single-option-selector:eq('+key+')').val(val);
					});
					item.find('.single-option-selector:last').change();
				}
			}
		});

		//Initialize slick on main product image
		if(item.find('#product-gallery').hasClass('display-Slider')) {
			item.find("#product-gallery .main-images").slick({
			  autoplay: false,
			  dots: false,
			  arrows: true,
			  fade: true,
			  pauseOnHover: false,
			  speed: 300,
			  prevArrow: '<i class="fa fa-angle-left animation left-arrow"></i>',
			  nextArrow: '<i class="fa fa-angle-right animation right-arrow"></i>'
			});
		}

		//Initialize slick on main product image for thumbs
		if(item.find('#thumbs-wrapper').hasClass('display-Slider')) {
		  item.find("#thumbs-wrapper #thumbs").slick({
			autoplay: false,
			dots: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: true,
			infinite: false,
			speed: 300,
			prevArrow: '<i class="fa fa-angle-left animation left-arrow"></i>',
			nextArrow: '<i class="fa fa-angle-right animation right-arrow"></i>',
			responsive: [
			  {
				breakpoint: 900,
				settings: {
				  slidesToShow: 5,
				  slidesToScroll: 1
				}
			  },
			  {
				breakpoint: 584,
				settings: {
				  slidesToShow: 4,
				  slidesToScroll: 1

				}
			  }
			]
		  });
		  item.find('#thumbs-wrapper a.gallery').click(function(){
			var index = item.find('#thumbs-wrapper a.gallery').index($(this));
			item.find("#product-gallery .main-images").slick('goTo', index);
			return false;
		  });
		}

		//Initialize photoswipe on main product image
		if(item.find('.main-images a.photoswipe').length > 0) {
		  item.find('.main-images a.photoswipe').photoSwipe();
		}
	}

	init();

  linkedOptions(product);
};

var linkedOptions = function(product) {
  // (c) Copyright 2016 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
  // See https://docs.shopify.com/themes/customization/navigation/link-product-options-in-menus

  var item = $('#product-item-'+product.id+':first');
  var optionsMap = {};
  
  var updateOptionsInSelector = function(selectorIndex) {
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = item.find('.single-option-selector:eq(0)');
        break;
      case 1:
        var key = item.find('.single-option-selector:eq(0)').val();
        var selector = item.find('.single-option-selector:eq(1)');
        break;
      case 2:
        var key = item.find('.single-option-selector:eq(0)').val();  
        key += ' / ' + item.find('.single-option-selector:eq(1)').val();
        var selector = item.find('.single-option-selector:eq(2)');
    }
  
    var initialValue = selector.val();
    selector.empty();
    selector.append('<option value="">- Select -</option>');

    if(key!="" && key!=" / ") {
      var availableOptions = optionsMap[key+'_'+product.id];
      for (var i=0; i<availableOptions.length; i++) {
        var option = availableOptions[i];
        var newOption = $('<option></option>').val(option).html(option);
        selector.append(newOption);
      }
      item.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
          $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
        }
        else {
          $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
        }
      });
      if ($.inArray(initialValue, availableOptions) !== -1) {
        selector.val(initialValue);
      }
    }
    
    selector.trigger('change');  
  };
  
  var linkOptionSelectors = function(product) {
    // Building our mapping object.
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      //if (variant.available) {
        // Gathering values for the 1st drop-down.
        optionsMap['root'+'_'+product.id] = optionsMap['root'+'_'+product.id] || [];
        optionsMap['root'+'_'+product.id].push(variant.option1);
        optionsMap['root'+'_'+product.id] = Shopify.uniq(optionsMap['root'+'_'+product.id]);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key+'_'+product.id] = optionsMap[key+'_'+product.id] || [];
          optionsMap[key+'_'+product.id].push(variant.option2);
          optionsMap[key+'_'+product.id] = Shopify.uniq(optionsMap[key+'_'+product.id]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          optionsMap[key+'_'+product.id] = optionsMap[key+'_'+product.id] || [];
          optionsMap[key+'_'+product.id].push(variant.option3);
          optionsMap[key+'_'+product.id] = Shopify.uniq(optionsMap[key+'_'+product.id]);
        }
      //}
    }
    // Update options right away.
    updateOptionsInSelector(0);
    if (product.options.length > 1) updateOptionsInSelector(1);
    if (product.options.length === 3) updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    item.find(".single-option-selector:eq(0)").change(function() {
      updateOptionsInSelector(1);
      if (product.options.length === 3) updateOptionsInSelector(2);
      return true;
    });
    // When there is an update in the second dropdown.
    item.find(".single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) updateOptionsInSelector(2);
      return true;
    });  
  }; 

  linkOptionSelectors(product);
}